module.exports = __webpack_public_path__ + "static/6-907d729aa1758c5d7917cf954714aa11.jpg";